import { times } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Swipeable from 'react-swipeable';
import { Absolute, Box, Flex, Relative } from 'rebass';
import styled from '../../node_modules/styled-components';
import { Text } from '../../src/components_new/common';
import Ratings from '../../src/components_new/common/Ratings';
import { buildPhotoPath } from '../helpers/photoutils';
import { colors } from './../../src/tailwind';
import buildLocation from './../helpers/buildLocation';

const slidePadding = 12;
const scale = 1.5;

export default class CardList extends Component {
  static propTypes = {
    items: PropTypes.array.isRequired,
    fixedWidth: PropTypes.number,
  };

  constructor(props) {
    super(props);

    this.state = {
      currentIndex: 0,
      translateValue: 0,
      windowWidth: 0,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    if (window && !this.props.fixedWidth) {
      window.addEventListener('resize', this.updateWindowDimensions);
    }
    if (this.props.fixedWidth) {
      this.setState({
        windowWidth: this.props.fixedWidth,
      });
    }
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }

  updateWindowDimensions() {
    this.setState({
      windowWidth: window.innerWidth - 64,
    });
  }

  goToPrevSlide = () => {
    const slideCount = this.getSlideCount();
    // Exiting the method early if we are at the beginning of the images array.
    // We also want to reset currentIndex and translateValue, so we return
    // to the first image in the array.
    const { currentIndex } = this.state;
    const { items } = this.props;
    if (currentIndex < slideCount) {
      const leftoverCount = items.length % slideCount;
      const idx = leftoverCount > 0 ? items.length - leftoverCount : items.length - slideCount;
      return this.setState({
        currentIndex: idx,
        translateValue: -(this.slideWidth() * idx),
      });
    }

    // This will not run if we met the if condition above
    this.setState((prevState) => ({
      currentIndex:
        prevState.currentIndex - slideCount >= 0 ? prevState.currentIndex - slideCount : 0,
      translateValue: prevState.translateValue + this.slideWidth() * slideCount,
    }));
  };

  goToNextSlide = () => {
    const count = this.getSlideCount();
    // Exiting the method early if we are at the end of the images array.
    // We also want to reset currentIndex and translateValue, so we return
    // to the first image in the array.
    if (this.state.currentIndex + count >= this.props.items.length) {
      return this.setState({
        currentIndex: 0,
        translateValue: 0,
      });
    }

    // This will not run if we met the if condition above
    this.setState((prevState) => ({
      currentIndex: prevState.currentIndex + count,
      translateValue: prevState.translateValue + -(this.slideWidth() * count),
    }));
  };

  slideWidth = () => {
    //15 is the scrollbar width
    return (this.state.windowWidth - 15) / this.getSlideCount();
  };

  getSlideCount = () => {
    const { windowWidth } = this.state;
    let slideCount = 1;
    if (windowWidth > 1900) {
      slideCount = 7;
    } else if (windowWidth > 1400) {
      slideCount = 6;
    } else if (windowWidth > 900) {
      slideCount = 5;
    } else if (windowWidth > 700) {
      slideCount = 4;
    } else if (windowWidth > 500) {
      slideCount = 2;
    } else if (this.props.loading) {
      slideCount = 4;
    }

    return slideCount;
  };

  swipeLeft = (e, distance) => {
    if (distance > 110) {
      this.goToPrevSlide();
    }
  };

  swipeRight = (e, distance) => {
    if (distance < -110) {
      this.goToNextSlide();
    }
  };

  render() {
    if (!this.props.items) {
      return <div> No items found </div>;
    }

    const { loading } = this.props;
    let ww = this.slideWidth();
    let useableWidth = ww > 0 ? ww : 0;
    const slideCount = this.getSlideCount();
    const currentIndex = this.state.currentIndex;
    //Wrap Slides in a slide group.
    return (
      <Swipeable onSwipedLeft={this.swipeLeft} onSwipedRight={this.swipeRight} trackMouse>
        <Slider className="slider" alignItems="center">
          {' '}
          <SliderButton
            className="nextArrow"
            left
            slideCount={slideCount}
            onClick={this.goToPrevSlide}
            loading={loading}
          >
            <i className="fas fa-chevron-left" />
          </SliderButton>
          <div
            style={{
              overflowX: 'hidden',
            }}
          >
            <SliderWrapper
              className="slider-wrapper"
              style={{
                transform: `translateX(${this.state.translateValue}px)`,
                transition: 'transform ease-out 0.45s',
                flexShrink: 1,
              }}
            >
              {loading
                ? times(slideCount, (n) => n).map((x) => (
                    <SlidePlaceholder width={useableWidth ? useableWidth : '220'} key={x}>
                      <Box bg={colors.coolGrayLight} style={{ height: '100%', width: '100%' }} />
                    </SlidePlaceholder>
                  ))
                : this.props.items.map((item, i) => (
                    <Slide
                      key={i}
                      item={item}
                      slideCount={slideCount}
                      currentIndex={currentIndex}
                      position={i}
                      width={useableWidth ? useableWidth : '220'}
                    />
                  ))}
            </SliderWrapper>
          </div>
          <SliderButton
            className="nextArrow"
            right
            slideCount={slideCount}
            onClick={this.goToNextSlide}
            loading={loading}
          >
            <i className="fas fa-chevron-right" />
          </SliderButton>
          {false && this.props.items.length > slideCount && (
            <Absolute top="40%" zIndex="0" right="37px" />
          )}
          {false && this.props.items.length > slideCount && (
            <Absolute top="40%" zIndex="0" left="-10px">
              <SliderButton
                className="nextArrow"
                left
                slideCount={slideCount}
                onClick={this.goToPrevSlide}
              >
                <i className="fas fa-chevron-left" />
              </SliderButton>
            </Absolute>
          )}
        </Slider>
      </Swipeable>
    );
  }
}

const SlidePlaceholder = styled.div`
  padding: 0 ${slidePadding}px;
  position: static;
  box-sizing: border-box;
  width: ${(p) => (p.width ? p.width + 'px' : '400')};
  display: inline-block;
  vertical-align: top;
  height: ${(p) => p.width * 1.2 + 'px'};
  transition: opacity 0.35s 0.2s ease;
`;

const Slider = styled(Flex)`
  width: ${(p) => (p.width ? p.width : '100%')};
  box-sizing: border-box;
  position: relative;
  z-index: 0;
`;

const SliderWrapper = styled.div`
  z-index: 1;
  position: relative;
  white-space: nowrap;
  padding-bottom: 6px;
`;

const A = styled.a`
  text-decoration: none;
  width: 100%;
  cursor: pointer;
`;

export function Slide(props) {
  const propTypes = {
    item: PropTypes.shape({
      coverPhoto: PropTypes.string,
      id: PropTypes.number,
      state: PropTypes.string,
      city: PropTypes.string,
      reviewsStarRating: PropTypes.number,
      reviewsCount: PropTypes.number,
      title: PropTypes.string,
      description: PropTypes.string,
    }),
  };

  const { width, item, currentIndex, slideCount, position, loading } = props;
  const detailUrl = `/details/${item.id}`;
  const dimension = width - slidePadding * 2;

  const location = buildLocation(item.listingAddresses, item);
  return (
    <SlideContainer
      className="slide"
      width={width}
      slideCount={slideCount}
      currentIndex={currentIndex}
      position={position}
      id={'item-card-' + item.id}
    >
      {position >= currentIndex && position <= currentIndex + slideCount - 1 && (
        <SlideInner name="slide-hover-container">
          <Relative>
            <A href={detailUrl}>
              <SlideImageContent>
                <SlideImage
                  src={buildPhotoPath('x_medium', item.coverPhoto || item.coverPhotoName)}
                  width={dimension}
                />
                <Absolute top={8} right={8} bg="rgba(60,60,60, .4)" py={'5px'} px={'5px'}>
                  <Text action white inline name="item-card-price">
                    <Text action white letterSpacing="2px" inline>
                      $
                    </Text>
                    {item.basePrice / 100 || '?'}
                  </Text>
                </Absolute>
                {item.description && (
                  <SlideDescriptionToggle>
                    <div className="toggle-bg" />
                    <ToggleContent>
                      <Text large grayMedium noclip clickable name="item-card-description">
                        {item.description.substring(0, 120)}
                        {item.description.length > 120 && '...'}
                      </Text>
                      <Text link bold>
                        see more
                      </Text>
                    </ToggleContent>
                  </SlideDescriptionToggle>
                )}
              </SlideImageContent>
            </A>
            <SlideContent>
              <Flex justifyContent="space-between">
                <Text grayMedium subtext name="item-card-location">
                  {location}
                </Text>
              </Flex>
              <A href={detailUrl}>
                <Text link t_title name="item-card-title">
                  {item.title}
                </Text>
              </A>
              <Flex
                justifyContent="flex-start"
                alignItems="center"
                height="12px"
                style={{ position: 'relative', top: '-2px' }}
              >
                {item.reviewsCount > 0 && item.reviewsCount ? (
                  <Ratings
                    small
                    rating={item.reviewScore || item.reviewsStarRating}
                    name="item-card-ratings"
                  />
                ) : null}
                <Text
                  ml={item.reviewsCount > 0 ? 2 : 0}
                  label
                  light
                  grayMedium
                  name="item-card-review-count"
                >
                  {(item.reviewsCount > 0 && item.reviewsCount) || 'no reviews'}
                </Text>
              </Flex>
            </SlideContent>
          </Relative>
        </SlideInner>
      )}
    </SlideContainer>
  );
}

const SlideContainer = styled.div`
  padding: 0 ${slidePadding}px;
  position: static;
  box-sizing: border-box;
  width: ${(p) => (p.width ? p.width + 'px' : '400')};
  display: inline-block;
  vertical-align: top;
  opacity: ${(p) =>
    p.position >= p.currentIndex && p.position <= p.currentIndex + p.slideCount - 1 ? 1 : 0};
  height: ${(p) =>
    p.position >= p.currentIndex && p.position <= p.currentIndex + p.slideCount - 1
      ? '100%'
      : '0px'};
  transition: opacity 0.35s 0.2s ease;
`;

const SlideInner = styled.div`
  z-index: 0;
  position: relative;
  transition: z-index .25s step-end

  box-shadow: 0 1px 3px 0 rgba(75, 75, 75, 0.25);
`;

const SlideContent = styled.div`
  z-index: 1;
  position: relative;
  padding: 12px;
  padding-bottom: 10px;
`;

const SlideImageContent = styled.div`
  z-index: 1;
  position: relative;
  width: '100%';
`;

const SlideImage = styled.img`
  object-fit: cover;
  width: ${(p) => p.width + 'px'};
  height: ${(p) => p.width + 'px'};
  background-color: white;
`;

const SlideDescriptionToggle = styled(SlideContent)`
  transform-origin: top;
  transition: transform 0.35s 0.2s ease;
  visibility: hidden;
  opacity: 0;
  width: 100%;
  white-space: normal;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  text-align: center;
  vertical-align: center;

  > .toggle-bg {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
    opacity: 0.85;
  }

  ${SlideInner}:hover & {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.35s 0.2s ease, transform 0.35s 0.2s ease;
  }
`;

const ToggleContent = styled.div`
  opacity: 0.99;
  position: relative;
  z-index: 5;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const SliderButton = styled.div`
  height: 35px;
  width: 24px;
  border-top-left-radius: ${(p) => (p.left ? '18px' : 0)};
  border-bottom-left-radius: ${(p) => (p.left ? '18px' : 0)};
  border-top-right-radius: ${(p) => (p.right ? '18px' : 0)};
  border-bottom-right-radius: ${(p) => (p.right ? '18px' : 0)};
  padding-left: 6px;
  font-size: 18px;
  color: white;
  padding-right: 6px;
  display: flex;
  background-color: #acacac;
  justify-content: ${(p) => (p.left ? 'flex-start' : 'flex-end')};
  align-items: center;
  cursor: pointer;
  opacity: ${(p) => (p.loading ? 0 : p.slideCount === 1 ? 1 : 0)};
  position: relative;
  right: ${(p) => (p.left ? '-12px' : null)};
  left: ${(p) => (p.right ? '-12px' : null)};
  z-index: 5;

  > svg {
    color: ${colors.white};
  }

  ${Slider}:hover & {
    opacity: 1;
  }
`;



// WEBPACK FOOTER //
// ./src/components_new/CardList.js